import { contactSection } from "data/contactSection";
import React from "react";
import { Col, Row } from "react-bootstrap";

const { title, contacts2, inputs } = contactSection;

const ContactInfoTwo = () => {
  return (
    <section className="contact-info-two">
      <div className="auto-container">
        <Row>
          {contacts2.map(({ id, icon,icon1, icon2, text, email, phone }) => (
            <Col key={id} md={12} lg={4}>
              <div className="contact-info-two__card animated fadeInUp">
                <i className={icon}></i>
                {icon2&& <i className={icon2}></i>}
                <a
                  href={
                    email
                      ? `mailto:${email}`
                      : phone
                      ? `tel:${text.split(" ").join("")}`
                      : "#"
                  }
                >
                  {text}
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default ContactInfoTwo;
